import type { QuizDto } from '@/api/webs'

/**
 * Whether two quizzes score answers the same way: the scale, the question, dimension and band IDs, which dimension each
 * question counts towards, reverse scoring, Not applicable, and the band ranges. The wording can differ.
 *
 * The same parts the server's answers lock (WebValidator.ValidateQuizAnswersLock) holds still once people have
 * answered. The editor only uses it to decide whether to offer going back to the signed-off version; the server
 * stays the judge of what may be saved and signed off.
 */
export function hasSameQuizStructure(first: QuizDto, second: QuizDto): boolean {
    if (first.ScaleMax !== second.ScaleMax) return false
    const questionShape = (quiz: QuizDto) => quiz.Questions.map(question => [question.Id, question.DimensionId, question.IsReverseScored, question.AllowsNotApplicable].join('|'))
    const bandShape = (quiz: QuizDto) => quiz.Bands.map(band => [band.Id, band.MinScore, band.MaxScore].join('|'))
    const dimensionShape = (quiz: QuizDto) => quiz.Dimensions.map(dimension => dimension.Id)
    return sameMembers(questionShape(first), questionShape(second))
        && sameMembers(dimensionShape(first), dimensionShape(second))
        && sameMembers(bandShape(first), bandShape(second))
}

/** Order doesn't matter: reordering questions or bands changes nobody's score. */
function sameMembers(first: string[], second: string[]): boolean {
    if (first.length !== second.length) return false
    const sortedSecond = [...second].sort()
    return [...first].sort().every((item, index) => item === sortedSecond[index])
}
